import { apiService } from './api';

export const dashboardService = {
  // Obtenir toutes les données du dashboard
  getDashboard: async () => {
    const response = await apiService.get('/dashboard');
    return response.data;
  },

  // 🔴 `getStockChart` ET `getMovementsChart` ONT ÉTÉ RETIRÉES AU LOT RU6 :
  // elles appelaient `/dashboard/stock-chart` et `/dashboard/movements-chart`,
  // **deux routes qui n'existent pas** dans le backend — mesuré, il n'a que
  // `/dashboard`, `/dashboard/alerts` et `/dashboard/quick-stats`. Zéro
  // appelant, donc personne ne l'a jamais découvert.
  // ⚠️ C'EST DU CODE MORT QUI MENT : il annonce une capacité qui n'existe pas.
  // Le graphique de ce lot aurait pu être branché dessus — le défaut se serait
  // alors découvert au premier affichage, en production. *Un code mort ne se
  // corrige pas : il se découvre faux le jour où on le ranime* (RU4-f, le
  // chariot d'une ligne produit — même famille, autre bout de l'application).

  // Obtenir les alertes du dashboard
  getDashboardAlerts: async () => {
    const response = await apiService.get('/dashboard/alerts');
    return response.data;
  },
}; 